import { createContext, useContext } from 'react';

// Types for collaboration (shared with CollabProvider)
export interface CollabUser {
  id: string;
  username: string;
  display_name?: string;
  email?: string;
  last_active: string;
}

export interface CollabEntityLock {
  entity_id: string;
  entity_type: string;
  user_id: string;
  acquired_at: string;
}

export interface CollabContextType {
  activeUsers: CollabUser[];
  locks: CollabEntityLock[];
  isConnected: boolean;
  isConnecting: boolean;
  acquireLock: (entityType: string, entityId: string) => Promise<boolean>;
  releaseLock: (entityType: string, entityId: string) => Promise<boolean>;
  sendComment: (content: string, entityType?: string, entityId?: string) => void;
}

export const CollabContext = createContext<CollabContextType | null>(null);

/** Hook for using the collaboration context. Use within CollabProvider. */
export function useCollaboration(): CollabContextType {
  const context = useContext(CollabContext);
  if (!context) {
    throw new Error('useCollaboration must be used within a CollabProvider');
  }
  return context;
}
